var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-customer",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0c11.038,0 20,8.962 20,20c-0,11.038 -8.962,20 -20,20c-11.038,0 -20,-8.962 -20,-20c-0,-11.038 8.962,-20 20,-20Zm-3.538,11.558l-3.447,-3.444c-0.047,-0.048 -0.119,-0.062 -0.181,-0.036c-0.062,0.025 -0.102,0.086 -0.102,0.153l-0.004,9.781c0.001,2.672 1.437,5.005 3.578,6.277c-2.763,0.905 -5.045,2.703 -6.547,5.046c-0.276,0.431 -0.333,0.531 -0.625,1.067c-0.066,0.121 -0.133,0.263 -0.174,0.411l0.001,-0.003c-0.028,0.082 -0.043,0.17 -0.043,0.262c-0,0.444 0.36,0.805 0.805,0.805c0.156,-0 0.424,-0.042 0.62,-0.393c0.164,-0.294 0.23,-0.405 0.541,-0.888c2.008,-3.12 5.259,-5.283 9.149,-5.283c3.732,-0 7.013,1.935 8.891,4.858c0.119,0.186 0.447,0.69 0.643,1.189c0.002,0.005 0.004,0.01 0.006,0.014c0.124,0.286 0.409,0.485 0.739,0.485c0.445,0 0.806,-0.361 0.806,-0.805c-0,-0.118 -0.026,-0.231 -0.072,-0.332c-0.173,-0.412 -0.598,-1.179 -0.943,-1.684c0,-0 0,-0 0,-0c-1.535,-2.238 -3.75,-3.918 -6.343,-4.754c2.155,-1.293 3.575,-3.616 3.577,-6.272l-0.004,-9.781c0,-0.067 -0.04,-0.128 -0.102,-0.153c-0.062,-0.026 -0.133,-0.012 -0.181,0.036c0,-0 -3.453,3.45 -3.453,3.45c-0.599,-0.599 -3.288,-3.286 -3.291,-3.29c-0.087,-0.093 -0.187,-0.132 -0.284,-0.13c-0.095,0.001 -0.193,0.042 -0.277,0.132c-0.004,0.004 -2.684,2.684 -3.283,3.282Zm9.267,4.651l0,1.801c0,3.141 -2.555,5.688 -5.696,5.688c-3.14,-0.004 -5.693,-2.552 -5.696,-5.691c-0,-0 -0,-1.798 -0,-1.798l11.392,0Zm0,-4.554l0,2.946l-11.392,-0l-0,-2.945c0.56,0.576 1.758,1.805 1.823,1.868c0.094,0.093 0.191,0.139 0.289,0.143c0.098,0.004 0.206,-0.032 0.32,-0.141c0.09,-0.087 2.672,-2.67 3.258,-3.256l3.255,3.253c0.104,0.104 0.209,0.149 0.309,0.15c0.103,0.001 0.21,-0.041 0.317,-0.151c0.285,-0.293 1.315,-1.348 1.821,-1.867Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRCustomer);
export default __webpack_public_path__ + "static/media/iconR-customer.c540a975c43f54a5653a670eac2f42d1.svg";
export { ForwardRef as ReactComponent };